import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { database } from '../lib/firebase'
import { ref, onValue } from 'firebase/database'
import { Container, Typography, Card, CardContent, Box } from '@material-ui/core'

import TopNavigation from '../components/TopNavigation'
import Footer from '../components/Footer'

const EntryDetail = () => {
  const { id } = useParams()
  const [entry, setEntry] = useState(null)

  useEffect(() => {
    const entryRef = ref(database, `/entries/${id}`)
    const unsubscribe = onValue(entryRef, (snapshot) => {
      setEntry(snapshot.val())
    })
    return () => unsubscribe()
  }, [id])

  if (!entry) return <Typography sx={{ m: 4 }}>Cargando...</Typography>
  const htmlString = entry.content;
  return (
    <>
      <TopNavigation />
      <br />
      <Container>
        <Typography variant="h2" align="center" sx={{ mt: 4, mb: 2 }}>{entry.title}</Typography>
        <center>
          <iframe
            width="50%"
            height="500px"
            frameBorder="0"
            src={entry.picture}
            title={entry.title}
            style={{ border: 'none', marginTop: '20px', display: 'block' }}
          ></iframe>
        </center>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 4,
            flexDirection: { xs: 'column', md: 'row' },
            maxWidth: '800px',
            mx: 'auto',
            my: 6,
            px: 2,
          }}
        >
          
          

    <div dangerouslySetInnerHTML={{ __html: htmlString }} />
             
            
          
        </Box>
      </Container>
      <br />
      <Footer />
    </>
  )
}

export default EntryDetail
